import classNames from "classnames";
import React from "react";
import { UIHelpers, UISize } from "../../utils/UIHints";
import { LazyLoadImage } from "../../misc";

import "./Avatar.scss";

export interface IAvatar {
  className?: string;
  source: string;
  rounded?: boolean;
  /**
   * The size prop is used sporadically and adds uncecessary complexity
   * to the sizing of the avatar. Prefer using CSS to size the component.
   */
  size?: UISize;
  title?: string;
  alt?: string;
}

const defaultAvatar = "/images/anon.jpg";

/**
 * Avatar image.
 *
 * Use of UISize needs review.
 *
 * @status review
 */
export class Avatar extends React.Component<IAvatar> {
  public static defaultProps: Partial<IAvatar> = {
    rounded: true
  };

  public static UISizes = UISize;

  public render() {
    const { alt, source, title, rounded, size, className } = this.props;

    const classes = classNames(`avatar`, size && UIHelpers.GetSizeClass(size), className, {
      "avatar-rounded": rounded,
    });

    return (
      <LazyLoadImage
        title={title}
        className={classes}
        src={source || defaultAvatar}
        fallbackSrc={defaultAvatar}
        alt={alt || ""}
      />
    );
  }
}
